import React, { useState } from "react";
import { stages } from "./quest";
import { Grid, Stack } from "@mui/material";
import { Button, Typography } from "antd";
import Result from "./result";

const PASS_SCORE = 11;
const OPTION_LETTERS = ["a", "b", "c", "d"];
const finalStage = { name: "A2+", group: "A2+" };

const Quiz = () => {
  const [stageIndex, setStageIndex] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [stageScore, setStageScore] = useState(0);
  const [globalScore, setGlobalScore] = useState(0);
  const [answered, setAnswered] = useState(0);
  const [result, setResult] = useState(null);

  const stage = stages[stageIndex];

  const handleAnswer = (answerIndex) => {
    const isCorrect =
      stage.questions[currentQuestion].answer === answerIndex + 1;
    const newStageScore = isCorrect ? stageScore + 1 : stageScore;

    setStageScore(newStageScore);
    setGlobalScore(isCorrect ? globalScore + 1 : globalScore);
    setAnswered(answered + 1);

    if (currentQuestion < stage.questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      return;
    }

    const isPassed = newStageScore >= PASS_SCORE;
    const isLastStage = stageIndex === stages.length - 1;

    if (isPassed && !isLastStage) {
      setStageIndex(stageIndex + 1);
      setCurrentQuestion(0);
      setStageScore(0);
      return;
    }

    setResult(isPassed ? finalStage : stage);
  };

  if (result) {
    return (
      <Result
        group={result.group}
        level={result.name}
        score={globalScore}
        answered={answered}
      />
    );
  }

  const currentQuestionData = stage.questions[currentQuestion];

  return (
    <Stack alignItems="center" justifyContent="center" spacing={3}>
      <Stack
        sx={{
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          mt: 6,
          gap: 1.5,
        }}
      >
        <Typography.Text type="secondary">
          {stage.name} · {currentQuestion + 1}/{stage.questions.length}
        </Typography.Text>
        <Typography.Title
          style={{
            fontWeight: "bold",
            fontSize: "medium",
            whiteSpace: "pre-line",
          }}
        >
          {currentQuestionData.title}

          <Typography.Title
            style={{
              fontWeight: "bold",
              fontSize: "medium",
              whiteSpace: "pre-line",
              paddingTop: 4,
            }}
          >
            {currentQuestionData.mainQuest}
          </Typography.Title>
        </Typography.Title>

        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 8, md: 12 }}
          sx={{
            placeItems: "center",
            placeContent: "center",
          }}
        >
          {currentQuestionData.options.map((option, index) => (
            <Grid item xs={6} key={index}>
              <Button
                danger
                style={{
                  width: "100%",
                  height: "auto",
                  whiteSpace: "normal",
                  color: "black",
                }}
                onClick={() => handleAnswer(index)}
              >
                {OPTION_LETTERS[index]}. {option}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Stack>
  );
};

export default Quiz;
